const OthersIcon = () => (
    <svg
        viewBox="0 0 79 79"
        fill="none"
    >
        <path
            d="M16.3264 32.6527H22.857C29.3877 32.6527 32.653 29.3874 32.653 22.8568V16.3262C32.653 9.79558 29.3877 6.53027 22.857 6.53027H16.3264C9.79582 6.53027 6.53052 9.79558 6.53052 16.3262V22.8568C6.53052 29.3874 9.79582 32.6527 16.3264 32.6527Z"
            stroke="#000"
            strokeWidth={4.89796}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M55.5103 32.6527H62.0409C68.5715 32.6527 71.8368 29.3874 71.8368 22.8568V16.3262C71.8368 9.79558 68.5715 6.53027 62.0409 6.53027H55.5103C48.9797 6.53027 45.7144 9.79558 45.7144 16.3262V22.8568C45.7144 29.3874 48.9797 32.6527 55.5103 32.6527Z"
            stroke="#000"
            strokeWidth={4.89796}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M55.5103 71.8363H62.0409C68.5715 71.8363 71.8368 68.571 71.8368 62.0404V55.5098C71.8368 48.9792 68.5715 45.7139 62.0409 45.7139H55.5103C48.9797 45.7139 45.7144 48.9792 45.7144 55.5098V62.0404C45.7144 68.571 48.9797 71.8363 55.5103 71.8363Z"
            stroke="#000"
            strokeWidth={4.89796}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16.3264 71.8363H22.857C29.3877 71.8363 32.653 68.571 32.653 62.0404V55.5098C32.653 48.9792 29.3877 45.7139 22.857 45.7139H16.3264C9.79582 45.7139 6.53052 48.9792 6.53052 55.5098V62.0404C6.53052 68.571 9.79582 71.8363 16.3264 71.8363Z"
            stroke="#000"
            strokeWidth={4.89796}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default OthersIcon;
